<template>
  <DataTable
    :striped-rows="true"
    :lazy="true"
    responsive-layout="scroll"
    filter-display="row"
    class="p-datatable-sm"
  >
    <slot name="before" />

    <Column
      v-if="showDetailButton || showEditButton || showDeleteButton"
      :exportable="false"
      style="width: 175px; min-width: 175px;"
    >
      <template #body="{data}">
        <Button
          v-if="!data.deletionDate && showDetailButton"
          icon="pi pi-eye"
          class="p-button-rounded p-button-secondary mx-1"
          :title="$t('dialog.editbarcode.title')"
          @click="openDetailDialog(data)"
        />

        <Button
          v-if="!data.deletionDate && showEditButton"
          icon="pi pi-pencil"
          class="p-button-rounded mx-1"
          :title="$t('action.crud.update')"
          @click="openEditDialog(data)"
        />

        <Button
          v-if="!data.deletionDate && showDeleteButton"
          icon="pi pi-trash"
          class="p-button-rounded p-button-danger mx-1"
          :title="$t('action.crud.delete')"
          @click="openDeleteDialog(data)"
        />
      </template>
    </Column>

    <Column
      field="code"
      :header="$t('entity.barcode.code')"
      :sortable="true"
      sort-field="start"
      :show-filter-menu="false"
      class="col-tab"
      style="width:300px"
    >
      <template #filter="{ filterModel, filterCallback }">
        <InputText
          v-model="filterModel.value"
          type="number"
          @change="filterCallback()"
        />
      </template>
      <template #body="{ data }">
        <div>
          {{ $t('entity.barcode.from') }} {{ data.start }} {{ $t('entity.barcode.to') }} {{ data.end }}
        </div>
      </template>
    </Column>

    <Column
      field="contact"
      :header="$t('entity.user.roles.contact')"
      :sortable="false"
      :show-filter-menu="false"
      class="col-tab"
    >
      <template #body="{ data }">
        <div v-if="data.contact">
          {{ data.contact.firstname }} {{ data.contact.lastname }}
        </div>
      </template>
    </Column>

    <Column
      field="creationUser"
      :header="$t('entity.user.roles.agent')"
      :sortable="true"
      :show-filter-menu="false"
      class="col-tab"
    >
      <template #body="{ data }">
        <div v-if="data.creationUser">
          {{ data.creationUser.firstname }} {{ data.creationUser.lastname }}
        </div>
      </template>
    </Column>

    <Column
      field="creationDate"
      :header="$t('entity.barcode.creationDate')"
      :sortable="true"
      sort-field="creationDate"
      :show-filter-menu="false"
      class="col-tab"
    >
      <template #body="{ data }">
        <div v-if="data.creationDate">
          {{ formatDateTime(data.creationDate) }}
        </div>
      </template>
    </Column>

    <Column
      field="deletionDate"
      :header="$t('entity.barcode.deleted')"
      :sortable="true"
      :show-filter-menu="false"
      filter-field="deleted"
      class="col-tab"
      style="width:300px"
    >
      <template #filter="{ filterModel, filterCallback }">
        <TriStateCheckbox
          v-model="filterModel.value"
          @change="filterCallback()"
        />
      </template>
      <template #body="{ data }">
        <div v-if="data.deletionDate && data.deletionUser">
          {{ formatDateTime(data.deletionDate) }} {{ $t('action.by') }} {{ data.deletionUser.firstname }} {{ data.deletionUser.lastname }}
        </div>
      </template>
    </Column>

    <BarcodeRangeDetailDialog
      v-if="selected"
      v-model:visible="showDetail"
      :barcode="selected"
    />

    <BarcodeEditDialog
      v-if="selected"
      v-model:visible="showEdit"
      :barcode="selected"
    />

    <BarcodeDeleteDialog
      v-if="toDelete"
      v-model:visible="showDelete"
      :barcode="toDelete"
      @delete="onDelete"
    />
  </DataTable>
</template>
<script>
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import TriStateCheckbox from "primevue/tristatecheckbox";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import BarcodeEditDialog from "@/components/barcodes/BarcodeEditDialog.vue";
import BarcodeDeleteDialog from "@/components/barcodes/BarcodeDeleteDialog";
import BarcodeRangeDetailDialog from "@/components/barcodes/BarcodeRangeDetailDialog.vue";

export default {
  name: "BarcodeTable",
  components: {
    BarcodeRangeDetailDialog,
    DataTable,
    Column,
    TriStateCheckbox,
    InputText,
    Button,
    BarcodeEditDialog,
    BarcodeDeleteDialog
  },
  props: {
    showDetailButton: {
      type: Boolean,
      default: false
    },
    showEditButton: {
      type: Boolean,
      default: false
    },
    showDeleteButton: {
      type: Boolean,
      default: false
    }
  },
  emits: ['delete', 'updateAppointment'],
  data() {
    return {
      showDelete: false,
      toDelete: null,
      showDetail: false,
      showEdit: false,
      selected: null
    }
  },
  watch: {
    showEdit() {
      if(!this.showEdit) this.$emit("updateAppointment");
    }
  },
  methods: {
    formatDateTime(date) {
      return new Date(date).toLocaleString(this.$i18n.locale)
    },
    openDeleteDialog(barcode) {
      this.toDelete = barcode;
      this.showDelete = true;
    },
    onDelete() {
      this.$emit('delete')
    },
    openDetailDialog(barcode) {
      this.selected = barcode;
      this.showDetail = true;
    },
    openEditDialog(barcode) {
      this.selected = barcode;
      this.showEdit = true;
    }
  }
}
</script>
